import { useMemo } from 'react'

import { Token, TokenAmount } from '../sdk'
import { useTokenContract } from '../hooks/useContract'
import { useSingleCallResult } from '../state/multicall/hooks'

export function useTokenAllowance(token?: Token, owner?: string, spender?: string): TokenAmount | undefined {
  const contract = useTokenContract(token?.address, false)

  const inputs = useMemo(() => [owner, spender], [owner, spender])
  const allowanceRaw = useSingleCallResult(contract, 'allowance', inputs).result?.[0]

  return useMemo(
    () =>
      token && allowanceRaw !== undefined && allowanceRaw !== null
        ? new TokenAmount(token, allowanceRaw.toString())
        : undefined,
    [token, allowanceRaw],
  )
}
